document.addEventListener("DOMContentLoaded", () => {

    if (document.querySelector(".ProductList--grid ")){
        document.querySelectorAll(".ProductList--grid ").forEach(item => {
            item.querySelectorAll(".add-to-cart-re").forEach(buttonwrap => {
                buttonwrap.querySelector(".ProductForm__AddToCart").classList.remove("Button--secondary")
                buttonwrap.querySelector(".ProductForm__AddToCart").classList.add("Button--primary")
            })
        })
    }
});